export default __webpack_public_path__ + "static/media/loadingIcon.9a83d4af.png";